import { Skeleton } from '../../components/Skeleton';

export function SurveyResponsesTilesSkeleton() {
  return (
    <div className="flex flex-col gap-4">
      <Skeleton className="h-[400px] w-full" />
      <Skeleton className="h-[400px] w-full" />
      <Skeleton className="h-[400px] w-full" />
    </div>
  );
}
